import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingCard() {
  return <section id="pricing" className="py-12 px-4 bg-white scroll-mt-10 border-t border-gray-200" data-id="element-122">
      <div className="max-w-2xl mx-auto" data-id="element-123">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-black text-center text-swiss-charcoal mb-8" data-id="element-124">
          Wählen Sie Ihr System.
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-125">
          {/* OPTION 1: BASIS */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-swiss-card-bg border border-gray-200 rounded-2xl p-6 flex flex-col" data-id="element-126">
            <h3 className="text-xl font-black text-swiss-charcoal mb-4 flex items-center gap-2" data-id="element-127">
              <span data-id="element-128">📦</span> OPTION 1: BASIS-SYSTEM
            </h3>

            <div className="space-y-3 mb-6 flex-grow" data-id="element-129">
              {['6 Módulos Core — 360 Seiten', '4 Toolkits Bonus — 240 Seiten', '10 Prüfungsmodelle mit Lösungen', '50 Praxis-Worksheets', 'Bewertungsraster und Vorlagen', 'Bilinguales Glossar DE/EN', 'Sofort-Download (PDF)', '100% Lehrplan 21 Konform'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-130">
                  <CheckCircle2Icon className="w-5 h-5 text-swiss-green-cta shrink-0" data-id="element-131" />
                  <span className="text-sm text-gray-700" data-id="element-132">{item}</span>
                </div>)}
            </div>

            <div className="text-center mb-6" data-id="element-133">
              <div className="text-3xl font-black text-swiss-charcoal" data-id="element-134">
                CHF 19.90
              </div>
            </div>

            <CTAButton href="https://suiza.kitonline.shop/cart/44586071982215:1" className="mb-4" data-id="element-135">
              📥 JETZT KAUFEN
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 text-xs text-gray-500 font-medium" data-id="element-136">
              <span className="flex items-center gap-1" data-id="element-137">
                <LockIcon className="w-3 h-3" data-id="element-138" /> Sichere Zahlung
              </span>
              <span data-id="element-139">|</span>
              <span data-id="element-140">7-Tage-Garantie</span>
              <span data-id="element-141">|</span>
              <span data-id="element-142">Sofortiger Zugang</span>
            </div>
          </motion.div>

          {/* OPTION 2: EXPERTEN */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-swiss-card-bg border-4 border-swiss-blue-expert rounded-2xl p-6 flex flex-col relative shadow-lg" data-id="element-143">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-swiss-blue-expert text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-144">
              EMPFOHLEN
            </div>

            <h3 className="text-xl font-black text-swiss-charcoal mb-2 flex items-center gap-2" data-id="element-145">
              <span data-id="element-146">🏆</span> OPTION 2: EXPERTEN-SYSTEM
            </h3>
            <div className="text-xs font-bold text-swiss-gold mb-4" data-id="element-147">
              ⭐ MEISTGEWÄHLT
            </div>

            <div className="space-y-3 mb-6 flex-grow" data-id="element-148">
              <div className="flex items-start gap-2 font-bold text-swiss-charcoal" data-id="element-149">
                <CheckCircle2Icon className="w-5 h-5 text-swiss-blue-expert shrink-0" data-id="element-150" />
                <span className="text-sm" data-id="element-151">Alles aus dem Basis-System +</span>
              </div>
              {['100 Schweizer Fallstudien — 80 Seiten', '25 Fälle: Unternehmensrecht (OR/ZGB)', '25 Fälle: Arbeitsstreitigkeiten (EAV/GAV)', '25 Fälle: Makroökonomie & SNB-Politik', '25 Fälle: KMU-Strategie in der Schweiz', 'Jeder Fall: Sachverhalt + Fragen + Musterlösung', 'Sofort-Download (PDF)', 'Updates inklusive'].map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-152">
                  <CheckCircle2Icon className="w-5 h-5 text-swiss-blue-expert shrink-0" data-id="element-153" />
                  <span className="text-sm text-gray-700" data-id="element-154">{item}</span>
                </div>)}
            </div>

            <div className="text-center mb-6" data-id="element-155">
              <div className="text-3xl font-black text-swiss-charcoal" data-id="element-156">
                CHF 23.90
              </div>
              <div className="text-xs text-gray-500 font-medium mt-1" data-id="element-157">
                Nur CHF 4.00 mehr als das Basis-System
              </div>
            </div>

            <CTAButton href="https://suiza.kitonline.shop/cart/44586143776903:1" className="mb-4" data-id="element-158">
              ✅ JETZT KAUFEN — EXPERTEN-SYSTEM
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 text-xs text-gray-500 font-medium" data-id="element-159">
              <span className="flex items-center gap-1" data-id="element-160">
                <LockIcon className="w-3 h-3" data-id="element-161" /> Sichere Zahlung
              </span>
              <span data-id="element-162">|</span>
              <span data-id="element-163">7-Tage-Garantie</span>
              <span data-id="element-164">|</span>
              <span data-id="element-165">Sofortiger Zugang</span>
              <span data-id="element-166">|</span>
              <span data-id="element-167">PDF</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}